module.exports = __webpack_public_path__ + "img/whatsapp.336c2144.svg";